export enum COOKIES {
  OAUTH_TOKEN = 'oauth_token',
  S_CSRF_TOKEN = 'x-s-csrf-token',
  VIEW_MODE = 'view_mode',
  TEMPORARY_DISABLE_COOKIES = 'temporary_disable_cookies',
  EXPLICIT_CONTENT_AGREED = 'cw_explicit_check_agreed',
  SORT_ORDER = 'cw_c_sort',
  SELLER_LOCATION = 'cw_s_loc',
  IN_MOBILE_APP = 'in_mobile_app',
  DONT_SHOW_COOKIE_BAR_AGAIN = 'dont_show_cookie_bar_again',
}
